export const GET_ANALYTICS_STICKY_COLUMNS = "GET_ANALYTICS_STICKY_COLUMNS";
export const GET_ANALYTICS_STICKY_COLUMNS_SUCCESS = "GET_ANALYTICS_STICKY_COLUMNS_SUCCESS";
export const GET_ANALYTICS_STICKY_COLUMNS_ERROR = "GET_ANALYTICS_STICKY_COLUMNS_ERROR";

export const UPDATE_ANALYTICS_STICKY_COLUMNS = "UPDATE_ANALYTICS_STICKY_COLUMNS";
export const UPDATE_ANALYTICS_STICKY_COLUMNS_SUCCESS = "UPDATE_ANALYTICS_STICKY_COLUMNS_SUCCESS";
export const UPDATE_ANALYTICS_STICKY_COLUMNS_ERROR = "UPDATE_ANALYTICS_STICKY_COLUMNS_ERROR";